import { createSlice } from "@reduxjs/toolkit";
import { AssessmentResponseDto } from "../../shared/dtos/assessment/AssessmentResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const assessmentSlice = createSlice({
  name: "assessment",
  initialState: getInitialCrudState<AssessmentResponseDto>(),
  reducers: {
    ...generateCrudReducers<AssessmentResponseDto>(),
  },
});

export const assessmentActions = assessmentSlice.actions;
export default assessmentSlice.reducer;
